// extracted by mini-css-extract-plugin
module.exports = {"container":"paymentRedirect_container__1sg4v","logo":"paymentRedirect_logo__5XFop"};